import { createApp } from "vue";
import { vfmPlugin } from "vue-final-modal";
import App from "./App.vue";
import axiosPlugin from "./axiosPlugin.mjs";
import router from "./router";
import store from "./store";
import translates from "./utilities/translates";
import { createI18n } from "vue-i18n";
import ToastPlugin from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";
import "flatpickr/dist/flatpickr.min.css";

const app = createApp(App);
// Create a new instance of VueI18n
const i18n = createI18n({
  locale: "it",
  fallbackLocale: "en",
  messages: translates,
});
app.use(axiosPlugin);
app.use(store);
app.use(ToastPlugin, {
  position: "top-right", // forza il posizionamento
  duration: 3500, // ms
  dismissible: true, // mostra la X
  pauseOnHover: true,
  queue: false,
});
app.use(i18n);
app.use(
  vfmPlugin({
    key: "$vfm",
    componentName: "VueFinalModal",
    dynamicContainerName: "ModalsContainer",
  })
);
app.use(router).mount("#app");
// Rendi axios disponibile globalmente
// app.config.globalProperties.$axios = axios;
